import { ContentSection, Heading } from '@cinch-labs/design-system'
import type { StoryBlokRichText } from '@cinch-nx/data-storyblok'
import { renderWithResolver } from '@cinch-nx/landing-ui-shared'

import { CookiesInstructions } from '../../types/policy-page'
import { InstructionsTable } from '../instructions-table/instructions-table'
import styles from './delete-cookies-section.module.css'

export type Props = {
  title: string
  pcNote: StoryBlokRichText
  pcInstructions: CookiesInstructions[]
  macNote: StoryBlokRichText
  macInstructions: CookiesInstructions[]
}

export const DeleteCookiesSection: React.FC<Props> = ({
  title,
  pcNote,
  pcInstructions,
  macNote,
  macInstructions,
}) => (
  <section className={styles.container}>
    <Heading element="h2" className={styles.title} fontSize="h1">
      {title}
    </Heading>
    <ContentSection>{pcNote && renderWithResolver(pcNote)}</ContentSection>
    <InstructionsTable instructions={pcInstructions} />
    <ContentSection>{macNote && renderWithResolver(macNote)}</ContentSection>
    <InstructionsTable instructions={macInstructions} />
  </section>
)
